export const useGetIsMeta = (): boolean => {
  return !!window["Odigeo"]?.SessionScope?.isMeta;
};
